import React from 'react'
import PropTypes from 'prop-types'
import { Captions } from 'lucide-react'
import styles from './styles'
import { InformationIcon } from '../icons'
import GuideIcon from '../icons/GuideIcon'

const EpisodeInfoIcons = ({
  hasSubtitles,
  hasInfoText,
  hasGuidanceText,
}) => (
  <div className="episode-icons">
    { hasSubtitles && (

      <Captions />
    )}
    { hasInfoText && (
      <InformationIcon />
    )}
    { hasGuidanceText && (
      <GuideIcon />
    )}
    <style jsx>{styles}</style>
  </div>
)

EpisodeInfoIcons.propTypes = {
  hasSubtitles: PropTypes.bool,
  hasInfoText: PropTypes.bool,
  hasGuidanceText: PropTypes.bool,
}

EpisodeInfoIcons.defaultProps = {
  hasSubtitles: false,
  hasInfoText: false,
  hasGuidanceText: false,
}

export default EpisodeInfoIcons
